export const debounce = (delay) => {
    return (func) => {
        let timeout = null;
        return (...args) => {
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };
};
